import * as React from 'react';
import PropTypes from "prop-types";

import { Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';

export class ProgramaConsulta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      unidades: props.unidadesOptions, anios: props.anioOptions, terminos: props.terminoOptions, unidad: props.unidadesValue, anio: props.aniosValue, termino: props.terminosValue
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = event => {
    this.props.onInputChange(event);
  }

  render() {
    return (
      <div>
        <form name="consulta" onSubmit={this.handleSubmit}>
          {this.props.unidadOptions.length > 0 &&
          <Row key={0} className="form-group">
            <Col md={2}>
              <label className=" control-label" htmlFor="unidad">Unidades:</label>
            </Col>
            <Col md={10} className="w-100">
              <Input
                type="select"
                placeholder="Unidades"
                name="unidad"
                id="unidad"
                value={this.props.unidadValue}
                onChange={this.handleChange}
              >
                {this.props.unidadOptions.map((uo, idx) => <option key={idx} value={uo.value} defaultValue={this.props.unidadValue}>{uo.label}</option>)}
              </Input>
            </Col>
          </Row>
          }
          <Row key={1} className="form-group">
            <Col md={2}>
              <label className=" control-label" htmlFor="programa">Programas:</label>
            </Col>
            <Col md={10} className="w-100">
                <Input
                type="select"
                placeholder="Programa"
                name="programa"
                id="programa"
                value={ this.props.programaValue }
                onChange={this.handleChange}
                maxLength={40}
                >
                {this.props.programaOptions.map((uo, idx) => <option key={ idx } value={uo.value }>{ uo.label }</option>)}
              </Input>
            </Col>
          </Row>
          {this.props.anioOptions && this.props.anioOptions.length > 0 && this.props.terminoOptions && this.props.terminoOptions.length > 0 &&
            <Row key={2} className="form-group">
              {this.props.anioOptions && this.props.anioOptions.length > 0 &&
                <>
                  <Col md={2}>
                    <label className=" control-label" htmlFor="anio">Año:</label>
                  </Col>
                  <Col md={4} className="w-100">
                    <Input
                      type="select"
                      value={this.props.anioValue}
                      placeholder="Año"
                      name="anio"
                      id="anio"
                      onChange={this.handleChange}>
                      {this.props.anioOptions.map((a, idx) => <option key={idx} value={a}>{a}</option>)}
                    </Input>
                  </Col>
                </>
              }
              {this.props.terminoOptions && this.props.terminoOptions.length > 0 &&
                <>
                  <Col md={2}>
                    <label className=" control-label" htmlFor="termino">Términos:</label>
                  </Col>
                  <Col md={4} className="w-100">
                    <Input
                      type="select"
                      name="termino"
                      value={this.props.terminoValue}
                      onChange={this.handleChange}>
                      {this.props.terminoOptions.map((t, idx) => <option key={idx} value={t}> {t}</option>)}
                    </Input>
                  </Col>
                </>
              }
            </Row>
          }
        </form>
      </div>
    );
  }
}

ProgramaConsulta.propTypes = {
  unidadesOptions: PropTypes.array,
  unidadesValue: PropTypes.any,
  aniosOptions: PropTypes.array,
  aniosValue: PropTypes.any,
  terminosOption: PropTypes.any,
  terminosValue: PropTypes.any,
  onChange: PropTypes.func,
};

